import {
  AuthProvider,
  useDescope,
  useSession,
  useUser,
} from '@descope/react-sdk';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { useDispatch } from 'react-redux';
import { Descope, SignUpOrInFlow } from '@descope/react-sdk';
import { Navigate } from 'react-router-dom';
import { updateUser } from './store/user';
import { apiEndpoint } from './constants/api';

export default function Login() {
  const dispatch = useDispatch();
  const loadUser = async (email, auth) => {
    const { data } = await axios.post(apiEndpoint(`/user/${email}`), auth);
    if(data && data.success !== undefined && !data.success){
      window.location = '/404';
    } else if(data){
      dispatch(updateUser({...data, auth }))
      window.location = '/admin/dashboard';
    }
  };

  return (
    <>
    <Helmet>
      <title>Login | Productions.com</title>
    </Helmet>
    <div className="flex min-h-full items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <AuthProvider
        projectId="P2Ls48J343RBjSAZ7wza3EpS2Vmj"
        tenantId="T2PhePBFSrnXMn9r5WGA2M3tF79U"
      >
        <Descope
          flowId="sign-up-or-in"
          theme="light"
          onSuccess={async (e) => {
            const { user } = e.detail;
            const auth = {
              refresh: e.detail.refreshJwt,
              session: e.detail.sessionJwt
            };
            loadUser(user.email, auth);
            
            
          
          }}
          onError={(err) => {
            console.log('Error!', err);
          }}
        />
      </AuthProvider>
    </div>
    </>
  );
}
